// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.break_dropdown_break__y8SA7 {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #575757;
  font-style: "normal";
}

.break_dropdown_container__ZbtOr {
  border-radius: 6px;
  border: 0.8px solid #dcdcdc;
  background-color: #fff;
}

.break_dropdown_container__ZbtOr:hover {
  cursor: pointer;
}

.break_dropdown_icon__rQau5 {
  background-color: #ebebeb;
  width: 40px;
  height: 40px;
  transition: "transform 0.3s ease";
}

.break_dropdown_list__l8rFy {
  min-width: 100%;
  top: 110%;
  left: 0;
  z-index: 10000000;
  border: 1px solid #d7d7d7;
  margin-top: 5px;
  border-radius: 5px;
  overflow: hidden;
  background-color: #fff;
}

.break_providerName_style__dcpnw {
  color: #aaaaaa;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 4px;
}

.break_dropdown_list__l8rFy li {
  margin-top: 5px;
  margin-bottom: 5px;
  background-color: #fff;
  padding: 4px 9px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 12px;
  text-align: center;
}

.break_dropdown_activelist_item__y3pjy {
  background-color: #ffd705 !important;
}

.break_timeselector__KripT {
  height: 50px;
}

.break_timeselector__KripT div {
  width: 100%;
  text-align: center;
  border: 0.4px solid #dcdcdc;
  color: #7d7d7d;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}

.break_selectedtimer_div__f3XP8 {
  border: 1px solid #ffd705 !important;
  background-color: #fbf8e6 !important;
  color: #2c2929 !important;
}

.break_dropdown_custom__BOJXM {
  min-width: 100%;
  max-height: 35vh;
  top: 110%;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 35vh !important;
  text-align: center;
  border: 0.4px solid #dcdcdc;
  color: #7f7f7f;
  background-color: #fff;
  border-radius: 8px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
}

.break_dropdown_listitems_both__E8LYw {
  max-height: 20vh;
  background-color: #fff;
  overflow: auto;
}

.break_dropdown_timeStyle__dHZlt {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #676767;
}

.break_dropdown_selectedTime_style__XQRnw {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #1e1919;
  background-color: #f1f1f1;
  border-radius: 5px;
}

.break_dropdown_button__FKEHh {
  border-radius: 5px;
  background-color: #ffd705;
  border: none;
  font-weight: Roboto;
  font-weight: 400;
  font-size: 12px;
  color: #553300;
}

.break_startTime_Input__lDkjp input {
  color: #7f7f7f;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-align: left;
  border: none;
  outline: none;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 6px;
}

/* .startTime_Input div:hover {
  border-radius: 8px;
  border: 0.8px solid #dcdcdc;
  background-color: transparent;
  padding: 0;
} */

.break_startTime_Input__lDkjp div {
  border-radius: 8px;
}

.break_startTime_Input__lDkjp {
  border: 0.8px solid #dcdcdc !important;
  border-radius: 8px;
  z-index: 100;
}

.break_startTime_Input__lDkjp label {
  color: #aaaaaa;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  top: 10px;
  z-index: 1;
}

.break_startTime_Input__lDkjp div fieldset {
  border: none;
  outline: none;
}

.break_startTime_Input__lDkjp div fieldset legend {
  transition: none;
  transform: none;
  float: initial !important;
  border: none;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Break/break.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf","sourcesContent":[".dropdown_break {\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: left;\n  color: #575757;\n  font-style: \"normal\";\n}\n\n.dropdown_container {\n  border-radius: 6px;\n  border: 0.8px solid #dcdcdc;\n  background-color: #fff;\n}\n\n.dropdown_container:hover {\n  cursor: pointer;\n}\n\n.dropdown_icon {\n  background-color: #ebebeb;\n  width: 40px;\n  height: 40px;\n  transition: \"transform 0.3s ease\";\n}\n\n.dropdown_list {\n  min-width: 100%;\n  top: 110%;\n  left: 0;\n  z-index: 10000000;\n  border: 1px solid #d7d7d7;\n  margin-top: 5px;\n  border-radius: 5px;\n  overflow: hidden;\n  background-color: #fff;\n}\n\n.providerName_style {\n  color: #aaaaaa;\n  font-family: Roboto;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  margin-bottom: 4px;\n}\n\n.dropdown_list li {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  background-color: #fff;\n  padding: 4px 9px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 12px;\n  text-align: center;\n}\n\n.dropdown_activelist_item {\n  background-color: #ffd705 !important;\n}\n\n.timeselector {\n  height: 50px;\n}\n\n.timeselector div {\n  width: 100%;\n  text-align: center;\n  border: 0.4px solid #dcdcdc;\n  color: #7d7d7d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  border-radius: 8px;\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.selectedtimer_div {\n  border: 1px solid #ffd705 !important;\n  background-color: #fbf8e6 !important;\n  color: #2c2929 !important;\n}\n\n.dropdown_custom {\n  min-width: 100%;\n  max-height: 35vh;\n  top: 110%;\n  left: 0;\n  z-index: 10000;\n  width: 100%;\n  height: 35vh !important;\n  text-align: center;\n  border: 0.4px solid #dcdcdc;\n  color: #7f7f7f;\n  background-color: #fff;\n  border-radius: 8px;\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.dropdown_listitems_both {\n  max-height: 20vh;\n  background-color: #fff;\n  overflow: auto;\n}\n\n.dropdown_timeStyle {\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 400;\n  text-align: left;\n  color: #676767;\n}\n\n.dropdown_selectedTime_style {\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 400;\n  text-align: left;\n  color: #1e1919;\n  background-color: #f1f1f1;\n  border-radius: 5px;\n}\n\n.dropdown_button {\n  border-radius: 5px;\n  background-color: #ffd705;\n  border: none;\n  font-weight: Roboto;\n  font-weight: 400;\n  font-size: 12px;\n  color: #553300;\n}\n\n.startTime_Input input {\n  color: #7f7f7f;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  text-align: left;\n  border: none;\n  outline: none;\n  width: 100%;\n  padding-top: 20px;\n  padding-bottom: 6px;\n}\n\n/* .startTime_Input div:hover {\n  border-radius: 8px;\n  border: 0.8px solid #dcdcdc;\n  background-color: transparent;\n  padding: 0;\n} */\n\n.startTime_Input div {\n  border-radius: 8px;\n}\n\n.startTime_Input {\n  border: 0.8px solid #dcdcdc !important;\n  border-radius: 8px;\n  z-index: 100;\n}\n\n.startTime_Input label {\n  color: #aaaaaa;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  top: 10px;\n  z-index: 1;\n}\n\n.startTime_Input div fieldset {\n  border: none;\n  outline: none;\n}\n\n.startTime_Input div fieldset legend {\n  transition: none;\n  transform: none;\n  float: initial !important;\n  border: none;\n  outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown_break": `break_dropdown_break__y8SA7`,
	"dropdown_container": `break_dropdown_container__ZbtOr`,
	"dropdown_icon": `break_dropdown_icon__rQau5`,
	"dropdown_list": `break_dropdown_list__l8rFy`,
	"providerName_style": `break_providerName_style__dcpnw`,
	"dropdown_activelist_item": `break_dropdown_activelist_item__y3pjy`,
	"timeselector": `break_timeselector__KripT`,
	"selectedtimer_div": `break_selectedtimer_div__f3XP8`,
	"dropdown_custom": `break_dropdown_custom__BOJXM`,
	"dropdown_listitems_both": `break_dropdown_listitems_both__E8LYw`,
	"dropdown_timeStyle": `break_dropdown_timeStyle__dHZlt`,
	"dropdown_selectedTime_style": `break_dropdown_selectedTime_style__XQRnw`,
	"dropdown_button": `break_dropdown_button__FKEHh`,
	"startTime_Input": `break_startTime_Input__lDkjp`
};
export default ___CSS_LOADER_EXPORT___;
